import gql from 'graphql-tag';

export const ContentSpaceKeyQuery = gql`
	query ContentSpaceKeyQuery($contentId: ID!) {
		content(id: $contentId, status: ["current", "draft"]) {
			nodes {
				id
				space {
					id
					key
					alias
				}
			}
		}
	}
`;
